module.exports = __webpack_public_path__ + "zl13-3e0d6b34.png";